import { Appointment } from '@web-app/hooks/queries/appointment-by-room-name/types';
import { CallPhase, payerActionEngine } from '@web-app/utils/payerActions';
import React from 'react';

interface PreCallPayerActionsProps {
  policies?: NonNullable<Appointment['user']>['policies'];
}

export const PreCallPayerActions = ({
  policies,
}: PreCallPayerActionsProps): JSX.Element | null => {
  if (!Array.isArray(policies) || policies.length === 0) {
    return null;
  }

  const actions = payerActionEngine.getActionsForPhase(
    CallPhase.PreCall,
    policies,
  );

  if (actions.length === 0) {
    return null;
  }

  return (
    <>
      {actions.map((action) => (
        <React.Fragment key={action.id}>{action.renderAction()}</React.Fragment>
      ))}
    </>
  );
};
